import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, List, Table, TableBody, TableCell, TableHead, TableRow, Alert } from '@mui/material';
import { ExpandMore, Rocket } from '@mui/icons-material';
import { SectionHeader, Done, Todo, CodeBlock } from './DocPrimitives';
import { FIRST_TIME_CHECKLIST_DONE, FIRST_TIME_CHECKLIST_TODO, DEPLOY_ORDER_COMMANDS, TROUBLESHOOTING_DONE, TROUBLESHOOTING_TODO, REQUIRED_SECRETS } from '../../data/docs/deployment';

export default function DeploymentTab() {
  return (
    <Box>
      <SectionHeader icon={<Rocket />} title="Deployment & Troubleshooting" subtitle="How to deploy, what to check when things go wrong" />

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>First-Time Deployment Checklist</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List dense disablePadding>
            {FIRST_TIME_CHECKLIST_DONE.map((item, i) => <Done key={i}>{item}</Done>)}
            {FIRST_TIME_CHECKLIST_TODO.map((item, i) => <Todo key={i}>{item}</Todo>)}
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Stack Deployment Order</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" color="text.secondary" mb={1}>
            The CI/CD pipeline handles ordering automatically. For manual deployments:
          </Typography>
          <CodeBlock>{DEPLOY_ORDER_COMMANDS}</CodeBlock>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Troubleshooting: Common Issues</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List dense disablePadding>
            {TROUBLESHOOTING_DONE.map((item, i) => <Done key={i}>{item}</Done>)}
            {TROUBLESHOOTING_TODO.map((item, i) => <Todo key={i}>{item}</Todo>)}
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Secrets That Must Be Set After Deploy</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Alert severity="error" sx={{ mb: 2 }}>
            <Typography variant="body2">These secrets are created with placeholder values by CDK. They <strong>must</strong> be updated in AWS Secrets Manager before the platform can process payments or send SMS.</Typography>
          </Alert>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><strong>Secret name pattern</strong></TableCell>
                <TableCell><strong>What it contains</strong></TableCell>
                <TableCell><strong>Where to get it</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {REQUIRED_SECRETS.map(({ name, what, where }) => (
                <TableRow key={name}>
                  <TableCell><code style={{ fontSize: '0.72rem' }}>{name}</code></TableCell>
                  <TableCell><Typography variant="caption">{what}</Typography></TableCell>
                  <TableCell><Typography variant="caption" color="text.secondary">{where}</Typography></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
